/**
 * WME orphan Globo cart guard
 * Reject checkout when EVERY line is a Globo option product.
 * Allows: parent video + options; real product + £0 discount codes.
 * Does NOT block on cart.total_price === 0.
 */
(function () {
  'use strict';

  var KNOWN_GLOBO_PRODUCT_IDS = {
    '10399651463511': true, // How many photos
    '10399657034071': true, // Delivery Time
    '10399664832855': true  // Extras
  };

  var MSG =
    'Add a video package before checkout — options alone can’t be purchased.';

  function isGloboLine(item) {
    if (!item) return false;
    var pid = String(item.product_id || item.productId || '');
    if (KNOWN_GLOBO_PRODUCT_IDS[pid]) return true;
    var handle = String(item.handle || '').toLowerCase();
    if (handle.indexOf('option-set-') === 0) return true;
    var title = String(item.product_title || item.title || '').toLowerCase();
    if (title.indexOf('how many photos') === 0) return true;
    if (title === 'delivery time' || title === 'extras') return true;
    // Globo often prefixes properties; product_type empty — rely on ids/handles
    return false;
  }

  function isOrphanGloboCart(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) return false;
    for (var i = 0; i < items.length; i++) {
      if (!isGloboLine(items[i])) return false;
    }
    return true;
  }

  function showBanner(on) {
    var id = 'wme-globo-cart-guard-banner';
    var el = document.getElementById(id);
    if (!on) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('div');
      el.id = id;
      el.setAttribute('role', 'alert');
      el.style.cssText =
        'position:fixed;bottom:0;left:0;right:0;z-index:99999;background:#111;color:#fff;padding:14px 18px;font:600 14px/1.4 system-ui,sans-serif;text-align:center';
      document.body.appendChild(el);
    }
    el.textContent = MSG;
  }

  function disableCheckout(on) {
    var sels = [
      '[name="checkout"]',
      'button[name="checkout"]',
      'input[name="checkout"]',
      'form[action="/cart"] [type="submit"]',
      'a[href="/checkout"]',
      '#checkout',
      '.cart__checkout-button',
      '[data-cart-checkout]',
      'button[form="cart"]'
    ];
    for (var s = 0; s < sels.length; s++) {
      var nodes = document.querySelectorAll(sels[s]);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (on) {
          n.setAttribute('disabled', 'disabled');
          n.setAttribute('aria-disabled', 'true');
          n.style.pointerEvents = 'none';
          n.style.opacity = '0.45';
          if (n.tagName === 'A') {
            n.setAttribute('data-wme-globo-blocked', '1');
            n.addEventListener('click', blockClick, true);
          }
        } else {
          n.removeAttribute('disabled');
          n.removeAttribute('aria-disabled');
          n.style.pointerEvents = '';
          n.style.opacity = '';
        }
      }
    }
  }

  function blockClick(e) {
    e.preventDefault();
    e.stopPropagation();
    showBanner(true);
  }

  function apply(cart) {
    var orphan = isOrphanGloboCart(cart);
    showBanner(orphan);
    disableCheckout(orphan);
    try {
      document.documentElement.classList.toggle('wme-globo-orphan-cart', orphan);
    } catch (e) {}
    return orphan;
  }

  function fetchCart(cb) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        cb(null, cart);
      })
      .catch(function (err) {
        cb(err);
      });
  }

  function refresh() {
    fetchCart(function (err, cart) {
      if (err || !cart) return;
      apply(cart);
    });
  }

  // Intercept checkout navigations when orphan
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var a = t.closest('a[href="/checkout"], a[href*="/checkouts/"], button[name="checkout"], [name="checkout"]');
      if (!a) return;
      fetchCart(function (err, cart) {
        if (err || !cart) return;
        if (isOrphanGloboCart(cart)) {
          e.preventDefault();
          e.stopPropagation();
          showBanner(true);
          disableCheckout(true);
        }
      });
    },
    true
  );

  // Form submit on /cart
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = (form.getAttribute('action') || '').toLowerCase();
      if (action.indexOf('/cart') === -1 && action.indexOf('checkout') === -1) return;
      // sync check via dataset flag set by last refresh
      if (document.documentElement.classList.contains('wme-globo-orphan-cart')) {
        e.preventDefault();
        showBanner(true);
      }
    },
    true
  );

  // Hook cart updates (Essential / theme events)
  var events = ['cart:updated', 'cart:refresh', 'essential:cart:updated'];
  for (var i = 0; i < events.length; i++) {
    document.addEventListener(events[i], refresh);
  }

  // Poll lightly on cart page
  refresh();
  if (/\/cart\/?$/.test(location.pathname)) {
    setInterval(refresh, 2500);
  }

  // Expose for tests
  window.WmeGloboCartGuard = {
    refresh: refresh,
    isGloboLine: isGloboLine,
    isOrphanGloboCart: isOrphanGloboCart,
    knownIds: KNOWN_GLOBO_PRODUCT_IDS
  };
})();
